import * as React from 'react';
import { DatasheetItem } from '@modules/datasheets/components/datasheet-item';
import { DatasheetItemLabel } from '@modules/datasheets/components/datasheet-item-label';
import { TextFieldProps, useTextFieldController } from './text-field.controller';
import { Flex } from '@common/components/Flex';
import { DatasheetFieldComponentHeadingPosition } from '@common/dto/datasheet/field-component/heading-position';
import { FieldContainer } from '../field-container';
import { FormControl } from '@common/components/form-control';
import { Hint } from '@common/components/hint';

import './text-field.styles.scss';

export const TextField: React.FC<TextFieldProps> = React.memo((props) => {
  const { datasheetElement } = props;

  const { 
    textFieldValue,
    headingPlacedHorizontally,
    headingReference,
    headingSize,
    headingPosition,
    handleTextFieldValueSave,
    handleTextFieldValueChange,
  } = useTextFieldController(props);

  const labelComponent = (
    <DatasheetItemLabel
      reference={headingReference}
      inline={headingPlacedHorizontally}
      withImg={datasheetElement.original.showfieldtype}
      withText={datasheetElement.original.headdisplay}
      text={datasheetElement.original.headtext} 
      img={datasheetElement.original.field.imageURL}
      textCustomization={{
        fontSize: datasheetElement.original.headfontsize,
        fontFamily: datasheetElement.original.headfont,
        color: datasheetElement.original.headcolor,
        align: datasheetElement.original.headalign,
        fontStyles: datasheetElement.original.headstyle,
      }}
    />
  );

  return (
    <DatasheetItem
      style={{
        top: datasheetElement.coordinates.y - (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.top 
          ? headingSize.height
          : 0),
        left: datasheetElement.coordinates.x - (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.left 
          ? headingSize.width 
          : 0),
        display: headingPlacedHorizontally ? 'flex' : 'block',
        alignItems: headingPlacedHorizontally ? 'flex-start' : undefined,
      }}
    >
      {[
        DatasheetFieldComponentHeadingPosition.top, 
        DatasheetFieldComponentHeadingPosition.left
      ].includes(headingPosition) && labelComponent}
      <Flex alignItems="center">
        <FieldContainer
          width={datasheetElement.original.width}
          height={datasheetElement.original.height}
          showBorder={datasheetElement.original.showborder}
        >
          <FormControl 
            value={textFieldValue}
            onBlur={handleTextFieldValueSave}
            onChange={handleTextFieldValueChange}
          />
        </FieldContainer>
        {datasheetElement.original.helptext && (
          <Hint description={datasheetElement.original.helptext} />
        )}
      </Flex>
      {[
        DatasheetFieldComponentHeadingPosition.bottom, 
        DatasheetFieldComponentHeadingPosition.right
      ].includes(headingPosition) && labelComponent}
    </DatasheetItem>
  );
});